import { useNavigate } from 'react-router-dom'
import ButtonV2 from '../../../common/components/atom/ButtonV2/Button'
import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import { AppRoleMembersTable, RequireCapability, rbacStrings } from '../../../features/rbac'

// Paramètres > Rôles & accès : assignation des rôles applicatifs (admin seul).
export default function RoleManagementPage() {
  const navigate = useNavigate()

  return (
    <div>
      <HeaderTitleContent>{rbacStrings.pageTitle}</HeaderTitleContent>
      <div style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>
        <ButtonV2
          onClick={() => navigate('/main/setting')}
          variant="outlined"
          size="medium"
          color="secondary"
        >
          ← Retour
        </ButtonV2>
      </div>
      <RequireCapability capability="users.manage">
        <p style={{ fontSize: 13, color: '#6b7280', marginBottom: '1rem' }}>
          {rbacStrings.pageIntro}
        </p>
        <AppRoleMembersTable />
      </RequireCapability>
    </div>
  )
}
